// Esto se hizo así porque había una url que se mandaba por e-mail que estaba mail
// pero eventualmente hay que quitar esta lógica y volver a la normalidad.
const url = new URL(window.location.href);
const isDownload =
  url.searchParams.get('download') === '1' &&
  /^\/order\/[^/]+\/tickets$/.test(url.pathname);

if (isDownload) {
  window.location.replace(
    `https://api.alltickets.com.ar${url.pathname}${url.search}`
  );
} else {
  import('./bootstrap');
}
